import { defineNuxtPlugin } from 'nuxt/app'
import { gql } from 'graphql-tag'

export default defineNuxtPlugin((nuxtApp) => {
  // updates state of all things
  setInterval(() => {
    nuxtApp.$apolloProvider.clients.defaultClient.mutate({
      mutation: gql`
        mutation UpdateLocalThingState {
          updateThingsState @client
        }
      `
    })
  }, 20000)
})
